import {
  TemplateParentTypeEnum,
  WidgetTypeConfig,
} from '@/types';
// V3
// eslint-disable-next-line import/no-cycle
import emailWidgetImageConfig from '@/components/template-builder/config/templates/email/widgets/widget-image-config';
// eslint-disable-next-line import/no-cycle
import displayWidgetImageConfig from '@/components/template-builder/config/templates/display/widgets/widget-image-config';
// eslint-disable-next-line import/no-cycle
import facebookWidgetImageConfig from '@/components/template-builder/config/templates/facebookmessenger/widgets/widget-image-config';
// V4
// eslint-disable-next-line import/no-cycle
import emailWidgetImageConfigV4 from '@/components/template-builder/config/templates/email-v4/widgets/widget-image-config';
// eslint-disable-next-line import/no-cycle
import getDisplayWidgetImageConfigV4 from '@/components/template-builder/config/templates/display-v4/widgets/widget-image-config';
// Teaser (display without link field)
// eslint-disable-next-line import/no-cycle
import { teaserWidgetImageConfig, teaserWidgetImageConfigV4 } from '@/components/template-builder/config/templates/teaser/widgets/widget-image-config';

const imageConfigV3 = {
  [TemplateParentTypeEnum.FACEBOOKMESSENGER]: facebookWidgetImageConfig,
  [TemplateParentTypeEnum.EMAIL]: emailWidgetImageConfig,
  [TemplateParentTypeEnum.POPUP]: displayWidgetImageConfig,
  [TemplateParentTypeEnum.EMBED]: displayWidgetImageConfig,
  [TemplateParentTypeEnum.TEASER]: teaserWidgetImageConfig,
};

const getImageConfigV4 = (templateType: string): WidgetTypeConfig | undefined => {
  switch (templateType) {
    case TemplateParentTypeEnum.FACEBOOKMESSENGER:
      return facebookWidgetImageConfig;
    case TemplateParentTypeEnum.EMAIL:
      return emailWidgetImageConfigV4;
    case TemplateParentTypeEnum.POPUP:
    case TemplateParentTypeEnum.EMBED:
      return getDisplayWidgetImageConfigV4(templateType);
    case TemplateParentTypeEnum.TEASER:
      return teaserWidgetImageConfigV4;
    default:
      return undefined;
  }
};

const getWidgetImageConfig = (templateType: string, isV4 = false): WidgetTypeConfig => {
  if (isV4) {
    return getImageConfigV4(templateType) ?? {};
  }
  if (
    templateType === TemplateParentTypeEnum.FACEBOOKMESSENGER
    || templateType === TemplateParentTypeEnum.EMAIL
    || templateType === TemplateParentTypeEnum.POPUP
    || templateType === TemplateParentTypeEnum.EMBED
    || templateType === TemplateParentTypeEnum.TEASER
  ) {
    return imageConfigV3[templateType];
  }
  return {};
};

export default getWidgetImageConfig;
